import { StateCreator } from 'zustand';

import {
  handleAddComment,
  handleAppendComments,
  handleClearEntry,
  handleInitEntry,
  handleRemoveComment,
  handleReplaceComment,
  handleSetComments,
  handleSetCreatingComment,
  handleSetDeletingCommentId,
  handleSetEditingCommentId,
  handleSetError,
  handleSetLoading,
  handleSetLoadingMore,
  handleSetUpdatingCommentId,
  handleUpdateComment,
} from './handlers';
import {
  HandlerSet,
  InboxEntryCommentsState,
  InboxEntryCommentsStore,
} from './types';

export const INITIAL_COMMENTS_STATE: InboxEntryCommentsState = {
  stateByEntry: {},
};

export const createInboxEntryCommentsSlice: StateCreator<
  InboxEntryCommentsStore
> = (set) => {
  const handlerSet: HandlerSet = (updater) => {
    if (typeof updater === 'function') {
      set(
        (fullState) => updater(fullState) as Partial<InboxEntryCommentsStore>,
      );
    } else {
      set(updater as Partial<InboxEntryCommentsStore>);
    }
  };

  return {
    ...INITIAL_COMMENTS_STATE,

    initEntry: (inboxEntryId) => handleInitEntry(handlerSet, inboxEntryId),
    clearEntry: (inboxEntryId) => handleClearEntry(handlerSet, inboxEntryId),
    setComments: (inboxEntryId, comments, exclusiveStartKey) =>
      handleSetComments(handlerSet, inboxEntryId, comments, exclusiveStartKey),
    appendComments: (inboxEntryId, comments, exclusiveStartKey) =>
      handleAppendComments(
        handlerSet,
        inboxEntryId,
        comments,
        exclusiveStartKey,
      ),
    addComment: (inboxEntryId, comment) =>
      handleAddComment(handlerSet, inboxEntryId, comment),
    updateComment: (inboxEntryId, comment) =>
      handleUpdateComment(handlerSet, inboxEntryId, comment),
    removeComment: (inboxEntryId, commentId) =>
      handleRemoveComment(handlerSet, inboxEntryId, commentId),
    replaceComment: (inboxEntryId, tempId, comment) =>
      handleReplaceComment(handlerSet, inboxEntryId, tempId, comment),
    setLoading: (inboxEntryId, isLoading) =>
      handleSetLoading(handlerSet, inboxEntryId, isLoading),
    setLoadingMore: (inboxEntryId, isLoadingMore) =>
      handleSetLoadingMore(handlerSet, inboxEntryId, isLoadingMore),
    setError: (inboxEntryId, error) =>
      handleSetError(handlerSet, inboxEntryId, error),
    setEditingCommentId: (inboxEntryId, commentId) =>
      handleSetEditingCommentId(handlerSet, inboxEntryId, commentId),
    setCreatingComment: (inboxEntryId, creating) =>
      handleSetCreatingComment(handlerSet, inboxEntryId, creating),
    setUpdatingCommentId: (inboxEntryId, commentId) =>
      handleSetUpdatingCommentId(handlerSet, inboxEntryId, commentId),
    setDeletingCommentId: (inboxEntryId, commentId) =>
      handleSetDeletingCommentId(handlerSet, inboxEntryId, commentId),
    resetState: () => set(INITIAL_COMMENTS_STATE),
  };
};
